import { Ability, AbilityBuilder } from '@casl/ability';
import { getPermissions } from './permissions';
export const ability = new Ability();
// Obtain permissions (rules) to be consumed by the Ability context
export const updateAbility = (currentAbility, role) => {
    // Get permissions based on user role
    const permissions = getPermissions(role);
    const { can, rules } = new AbilityBuilder(Ability);
    permissions.forEach((permission) => {
        const [action, subject] = permission.split('_');
        if (action && subject) {
            can(action, subject);
        }
    });
    currentAbility.update(rules);
};
// Re-export types and hooks from CASL package so that they don't need to be installed separately in the frontend projects
export { Ability } from '@casl/ability';
export { useAbility } from '@casl/react';
